<script lang="ts">
  import { onMount } from "svelte";
  import Button from "../../shared/button.svelte";
  import { locale, t } from 'svelte-i18n';
  import IntersectionObserver from 'svelte-intersection-observer';

  export let element: HTMLElement = undefined;
  let videoEntryReference: HTMLElement;
  let paused: boolean = true;
  let muted: boolean = true;
  let mobileMuteButton: 'muted' | 'not-muted' | undefined = undefined;
  let mobileMuteTimeout;
  let iso: string = 'pt';

  onMount(() => {
    locale.subscribe((isoValue) => {
      iso = isoValue;
    });
  })

  let video: HTMLVideoElement;

  function clickHandler(e) {
    muted = !muted;

    mobileMuteButton = muted ? 'not-muted' : 'muted';
    mobileMuteTimeout = undefined;
    mobileMuteTimeout = setTimeout(() => {
      mobileMuteButton = undefined;
    }, 1500);
  }

  function handleVideoIntersection(event) {
    if (!event.detail || !video) {
      return;
    }

    if (event.detail.isIntersecting) {
      video.play();
      return;
    }

    video.pause();
  }
</script>

<section class="c-video">
  <div class="relative flex pt-[80%] md2:pt-[56.25%] xl:pt-0 xl:h-[702px] xl:w-[1248px] { muted ? `c-cursor--muted-${iso}` : `c-cursor--not-muted-${iso}` }">
    <video id="home-video" class="bg-white absolute top-0 right-0 w-full h-full h-auto object-cover z-20 md2:rounded-[14px] lg:rounded-[16px] xl-rounded-[20px]"
      bind:this={video}
      bind:paused={paused}
      on:click={clickHandler}
      bind:muted={muted}
      playsinline
      loop
      >
    <!--   <source src={$t('VIDEO.WEBM')} type="video/webm" /> -->
      <source src={$t('VIDEO.MP4')} type="video/mp4" />
    </video>
    <IntersectionObserver element={videoEntryReference} on:observe={handleVideoIntersection}>
      <div bind:this={videoEntryReference} class="absolute inset-x-2/4 top-2/4 translate-y-[-50%] translate-x-[-50%]"></div>
      <img class="absolute inset-x-2/4 top-2/4 translate-y-[-50%] translate-x-[-50%] h-12 z-30 pointer-events-none transition-opacity transition-150 ease-in-out { mobileMuteButton === 'muted' ? 'opacity-100 lg:opacity-0' : 'opacity-0' }" src="images/muted.svg" alt="muted">
      <img class="absolute inset-x-2/4 top-2/4 translate-y-[-50%] translate-x-[-50%] h-12 z-30 pointer-events-none transition-opacity transition-150 ease-in-out { mobileMuteButton === 'not-muted' ? 'opacity-100 lg:opacity-0' : 'opacity-0' }" src="images/not-muted.svg" alt="not muted">
    </IntersectionObserver>
  </div>

  <a href="/work" class="block relative my-[2.5rem] sm:my-12 md:my-[3.5rem] mx-auto md2:m-0 md2:absolute md2:bottom-[3.5rem] md2:left-[50%] md2:z-30 md2:translate-y-2/4 md2:translate-x-[-50%] md2:shadow-video-button md2:rounded-md2 md2:h-12 z-40">
    <Button shadow="true" variant="yellow" label={$t('HOME.VIDEO_CTA')}>
    </Button>
  </a>
  <span class="absolute bottom-0 h-32 w-[100vw] xl:w-[1248px] lg:bg-video-bottom pointer-events-none z-20" />
  <span class="absolute top-[calc(100vh-72px)]" bind:this={element} />
</section>

<style lang="scss">
  .c-video {
    @apply relative flex flex-col xl:items-center overflow-hidden bg-blue-bg z-20; 
    @apply md2:pt-32 md2:px-[4.5rem] lg:pt-36 lg:px-40 xl:pt-40 xl:px-44;
  }
  .c-cursor {
    &--muted {
      &-pt {
        cursor: url('../cursors/muted-pt.svg') 25 25, url('../cursors/muted-pt.cur') 25 25, pointer;
      }

      &-en {
        cursor: url('../cursors/muted-en.svg') 25 25, url('../cursors/muted-en.cur') 25 25, pointer
      }
    }

    &--not-muted {
      &-pt {
        cursor: url('../cursors/not-muted-pt.svg') 25 25, url('../cursors/not-muted-pt.cur') 25 25, pointer;
      }

      &-en {
        cursor: url('../cursors/not-muted-en.svg') 25 25, url('../cursors/not-muted-en.cur') 25 25, pointer
      }
    }
  }
</style>